import useKeyboardShortcuts from './useKeyboardShortcuts';

export default useKeyboardShortcuts;